import { useRouter } from 'app/hooks/useRouter'
import useSettings from 'app/hooks/useSettings'
import { useLocation } from 'react-router-dom'

export default function MatxLogo({ className }) {
  const { settings } = useSettings()
  const router = useRouter()
  const location = useLocation()
  const targetPath = '/dashboard/admin/statistics'
  const isCurrentPath = location.pathname === targetPath
  const handleClick = () => {
    if (!isCurrentPath) {
      router.push(targetPath)
    }
  }
  return (
    <img
      src={'/assets/images/logos/new_logo.png'}
      alt="Logo"
      width={150}
      // height={30}
      onClick={handleClick}
      className={className}
      style={{ cursor: isCurrentPath ? 'default' : 'pointer' }}
    />
  )
}

// <svg
//   width="50px"
//   height="30px"
//   viewBox="0 0 128 213"
//   fill="none"
//   xmlns="http://www.w3.org/2000/svg"
// >
//   <g clip-path="url(#clip0_21_396)">
//     <path
//       d="M52.3795 33.9341C52.7445 34.5953 54.1567 34.6753 54.8443 34.7286C58.1924 34.9845 61.678 34.5366 64.7193 33.1023C69.4479 30.8734 72.4681 25.3119 76.0595 33.3102C79.1008 40.0768 79.2225 46.2301 79.5663 51.3224C80.1534 59.9339 80.4443 64.237 82.0364 68.8333C84.316 75.4133 88.3359 79.9456 91.1973 82.6384C91.1973 82.6384 84.3266 78.394 79.9418 72.6405C75.5041 66.8178 73.1874 61.0697 71.9233 57.0545C71.881 57.0119 71.8175 56.9532 71.7382 56.9479C71.2939 56.9265 70.913 58.4889 70.9078 58.7875C70.8337 63.2559 75.4407 69.1479 75.4407 69.1479C81.2535 75.4666 103.019 103.909 107.494 125.328C108.097 128.213 112.127 149.11 98.8985 164.882C84.6651 181.855 61.2284 180.047 58.3722 179.78L62.9369 175.317C95.6773 134.265 62.2757 84.2967 57.0922 40.0715C56.6955 39.2076 54.5005 39.3143 53.4162 39.0477C50.5177 38.3278 43.3349 35.3525 42.9858 31.9559C42.5785 28.042 47.4235 27.3595 48.2116 23.9362C50.0893 26.437 52.8608 27.93 56.0291 27.8767L53.5061 26.8743C47.2383 23.7123 46.757 9.53396 50.084 4.13777C53.9821 -2.18622 62.7094 -0.805176 66.2532 5.09224C69.7759 10.9523 66.0099 17.351 67.6337 23.6749C68.0145 25.152 69.2099 26.2931 68.2578 27.9834C66.9355 30.3242 55.3944 34.0088 52.3848 33.9288L52.3795 33.9341ZM52.7286 167.97C72.9283 151.781 77.3289 116.141 63.7197 78.8792C65.5815 85.6191 76.6466 128.207 51.5861 159.939C45.5934 167.527 38.7385 172.977 32.3068 176.901C42.0813 175.136 48.5554 171.313 52.7286 167.97ZM45.8631 60.2112L42.9329 69.2119C31.3547 100.635 1.70843 126.624 6.01917 162.803L6.50049 164.808C6.07735 125.259 42.9329 98.8003 45.8631 60.2112Z"
//       fill="url(#paint0_linear_21_396)"
//     />
//     <path
//       d="M10.0866 208.58L16.2592 194.359H19.1101L20.1415 213H17.2906L16.5342 196.977H16.4231L9.38314 213H8.99174L2.08926 197.622H1.97818L1.22182 213H0L1.0314 194.359H3.62843L10.0813 208.58H10.0866ZM32.1269 213H29.4188V206.073L23.1035 194.359H26.1501L31.3177 205.06L36.1521 194.359H37.5484L32.1269 205.935V213.005V213ZM45.3659 213L53.6648 193.905H54.0826L62.3815 213H59.3349L57.2403 207.929H48.9415L46.8734 213H45.3659ZM49.3593 206.857H56.7907L53.1041 197.734L49.3593 206.857ZM65.1742 213V194.359H70.4529C72.595 194.359 74.2982 194.727 75.5676 195.457C76.8317 196.188 77.4664 197.286 77.4664 198.752C77.4664 199.787 77.1068 200.683 76.3927 201.44C75.6734 202.202 74.6737 202.778 73.3884 203.173C75.081 203.493 76.361 204.069 77.2284 204.906C78.0959 205.743 78.5296 206.655 78.5296 207.652C78.5296 208.649 78.2757 209.497 77.7732 210.201C77.2707 210.904 76.6255 211.443 75.8479 211.822C74.2664 212.611 72.6426 213.005 70.9871 213.005H65.1742V213ZM67.8823 202.89H69.8922C71.5848 202.89 72.8013 202.512 73.5365 201.749C74.2717 200.987 74.642 200.037 74.642 198.891C74.642 198.123 74.3881 197.425 73.875 196.795C73.362 196.166 72.5739 195.692 71.516 195.372C70.2519 195.372 69.0407 195.558 67.8823 195.937V202.89ZM67.8823 203.706V211.731C68.48 211.918 69.4003 212.014 70.6486 212.014C71.8969 212.014 73.0023 211.667 73.9702 210.974C74.9382 210.281 75.4248 209.31 75.4248 208.073C75.4248 206.836 74.8959 205.796 73.8327 204.959C72.7696 204.122 71.4949 203.706 70.0033 203.706H67.8823ZM80.9309 213L89.2297 193.905H89.6476L97.9464 213H94.8998L92.8053 207.929H84.5064L82.4383 213H80.9309ZM84.9243 206.857H92.3557L88.6691 197.734L84.9243 206.857ZM106.266 213H103.558V206.073L97.243 194.359H100.29L105.457 205.06L110.292 194.359H111.688L106.266 205.935V213.005V213ZM110.99 213L119.289 193.905H119.706L128.005 213H124.959L122.864 207.929H114.565L112.497 213H110.99ZM114.983 206.857H122.415L118.728 197.734L114.983 206.857Z"
//       fill="url(#paint1_linear_21_396)"
//     />
//   </g>
//   <defs>
//     <linearGradient
//       id="paint0_linear_21_396"
//       x1="5.59074"
//       y1="89.9862"
//       x2="108.541"
//       y2="89.9862"
//       gradientUnits="userSpaceOnUse"
//     >
//       <stop stop-color="#E8D490" />
//       <stop offset="1" stop-color="#B99142" />
//     </linearGradient>
//     <linearGradient
//       id="paint1_linear_21_396"
//       x1="0"
//       y1="203.45"
//       x2="128"
//       y2="203.45"
//       gradientUnits="userSpaceOnUse"
//     >
//       <stop stop-color="#E8D490" />
//       <stop offset="1" stop-color="#B99142" />
//     </linearGradient>
//     <clipPath id="clip0_21_396">
//       <rect width="128" height="213" fill="white" />
//     </clipPath>
//   </defs>
// </svg>
